// extracted by mini-css-extract-plugin
module.exports = {"panel":"Panel_panel__3bO4E","tall":"Panel_tall__3pS8S","wide":"Panel_wide__3azVe"};